(function () {
    'use strict';
    angular.module("EventListApp").directive('wsSpinner', function () {
        return {
            restrict: 'EA',
            replace: true,
            scope: {},
            bindToController: {
                name: '@?',
                group: '@?',
                show: '=?',
                imgSrc: '@?',
                register: '@?',
                onLoaded: '&?',
                onShow: '&?',
                onHide: '&?'
            },
            controllerAs: 'vm',
            template: [
              '<div ng-show="vm.show" class="spinner text-center">',
              '   <span class="mdi mdi-loading mdi-spin" ></span> <span class="visually-hidden">Loading...</span>',
              '</div>'
            ].join(''),
            controller: ['$scope', 'SpinnerService', function ($scope, spinnerService) {
                var vm = this;

                // bindings are only assigned to the controller by the time $onInit runs
                vm.$onInit = function () {
                    // register should be true by default if not specified.
                    if (vm.register === undefined) {
                        vm.register = true;
                    } else {
                        vm.register = vm.register.toLowerCase() === 'false' ? false : true;
                    }

                    // Declare a mini-API to hand off to our service so the directive
                    // doesn't have a direct reference to this directive's scope.
                    var api = {
                        name: vm.name,
                        group: vm.group,
                        show: function () {
                            vm.show = true;
                        },
                        hide: function () {
                            vm.show = false;
                        },
                        toggle: function () {
                            vm.show = !vm.show;
                        }
                    };

                    // Register this spinner with the spinner service.
                    if (vm.register === true) {
                        spinnerService._register(api);
                    }

                    // If an onShow or onHide expression was provided, register a watcher
                    // that will fire the relevant expression when show's value changes.
                    if (vm.onShow || vm.onHide) {
                        $scope.$watch(function () {
                            return vm.show;
                        }, function (show) {
                            if (show && vm.onShow) {
                                vm.onShow({ spinnerService: spinnerService, spinnerApi: api });
                            } else if (!show && vm.onHide) {
                                vm.onHide({ spinnerService: spinnerService, spinnerApi: api });
                            }
                        });
                    }

                    // This spinner is good to go. Fire the onLoaded expression.
                    if (vm.onLoaded) {
                        vm.onLoaded({ spinnerService: spinnerService, spinnerApi: api });
                    }
                };
            }]
        };
    });
})();

